import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const PAGE_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'Page',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Page',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Page',
    column_type: 'datetime',
  },
  slug: {
    model_name: 'Page',
    column_type: 'string',
  },
  title: {
    model_name: 'Page',
    column_type: 'string',
  },
  type: {
    model_name: 'Page',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  application: {
    model_name: 'Page',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
    },
  },
  application_id: {
    model_name: 'Page',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
    },
  },
  views_count: {
    model_name: 'Page',
    column_type: 'integer',
  },
  published_at: {
    model_name: 'Page',
    column_type: 'datetime',
  },
  wxacode: {
    model_name: 'Page',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  content: {
    model_name: 'Page',
    column_type: 'text',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
